var buildKey = function buildKey(service, path) {
  return "".concat(service, "_").concat(path);
};

var SERVICES = {
  JOB_POSITIONS: 'job_position',
  WORKER_JOB_POSITIONS: 'worker_job_positions',
  WORKERS: 'worker',
  RESTAURANTS: 'restaurants',
  ACCOUNTS: 'accounts',
  ORGANISATIONS: 'organisations',
  EMPLOYERS: 'employers'
};
var JOB_POSITIONS = {
  STATUS: buildKey(SERVICES.JOB_POSITIONS, 'status'),
  LIST: buildKey(SERVICES.JOB_POSITIONS, 'list'),
  APPLICATION_PERFORMANCE_METRICS: buildKey(SERVICES.JOB_POSITIONS, 'application_performance_metrics'),
  DETAILS: buildKey(SERVICES.JOB_POSITIONS, 'details'),
  ASSESSMENT_QUESTIONS: buildKey(SERVICES.JOB_POSITIONS, 'assessment_questions')
};
var WORKER_JOB_POSITIONS = {
  SPONTANEOUS_APPLICATION: buildKey(SERVICES.WORKER_JOB_POSITIONS, 'spontaneous_application'),
  APPLICATIONS: buildKey(SERVICES.JOB_POSITIONS, 'applications'),
  SHOW_JOB_APPLICATION_COMPLAINT: buildKey(SERVICES.WORKER_JOB_POSITIONS, 'show_job_application_complaint'),
  SHOW_JOB_APPLICATION: buildKey(SERVICES.WORKER_JOB_POSITIONS, 'show_job_application')
};
var WORKERS = {
  HAS_NO_EXPERIENCE: buildKey(SERVICES.WORKERS, 'has_no_experience'),
  FETCH_WORKER_DETAILS: buildKey(SERVICES.WORKERS, 'fetch_worker_details'),
  SHOW_PAST_EXPERIENCE: buildKey(SERVICES.WORKERS, 'show_past_experience'),
  LIST_REFERENCES: buildKey(SERVICES.WORKERS, 'list_references'),
  FETCH_WORKER_PAST_EXPERIENCES: buildKey(SERVICES.WORKERS, 'fetch_worker_past_experiences'),
  FETCH_WORKER_REFERENCES: buildKey(SERVICES.WORKERS, 'fetch_worker_references'),
  CV_PARSING_JOB_STATUS: buildKey(SERVICES.WORKERS, 'cv_parsing_job_status')
};
var RESTAURANTS = {
  LIST: buildKey(SERVICES.RESTAURANTS, 'list'),
  LOCATIONS: buildKey(SERVICES.RESTAURANTS, 'locations'),
  NAMES: buildKey(SERVICES.RESTAURANTS, 'names'),
  DETAILS: buildKey(SERVICES.RESTAURANTS, 'details'),
  EMPLOYEES: buildKey(SERVICES.RESTAURANTS, 'employees'),
  OTHER_RESTAURANT_VALUES: buildKey(SERVICES.RESTAURANTS, 'other_restaurant_values')
};
var ACCOUNTS = {
  LIST_USER_CONTACTS: buildKey(SERVICES.ACCOUNTS, 'list_user_contacts')
};
var ORGANISATIONS = {
  DETAILS: buildKey(SERVICES.ORGANISATIONS, 'details'),
  COMPANY_LIST: buildKey(SERVICES.ORGANISATIONS, 'company-list'),
  STRIPE_PAYMENT_METHODS: buildKey(SERVICES.ORGANISATIONS, 'stripe_payment_methods'),
  STRIPE_CUSTOMER_PORTAL: buildKey(SERVICES.ORGANISATIONS, 'stripe_customer_portal'),
  MISSED_APPLICATION_ACTIVITIES: buildKey(SERVICES.ORGANISATIONS, 'missed_application_activities'),
  PERFORMANCE_METRICS: buildKey(SERVICES.ORGANISATIONS, 'performance_metrics'),
  CREATE_COMPANY: buildKey(SERVICES.ORGANISATIONS, 'create_company')
};
var EMPLOYERS = {
  COMPANY_SEARCH: buildKey(SERVICES.EMPLOYERS, 'company_search')
};
export var QUERY_KEYS = {
  JOB_POSITIONS: JOB_POSITIONS,
  WORKER_JOB_POSITIONS: WORKER_JOB_POSITIONS,
  WORKERS: WORKERS,
  RESTAURANTS: RESTAURANTS,
  ACCOUNTS: ACCOUNTS,
  ORGANISATIONS: ORGANISATIONS,
  EMPLOYERS: EMPLOYERS
};